import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { PermissionsRequestsToast } from '@gem/call/CallView/FullScreenCallView/Shared/PermissionsRequestsToast/PermissionsRequestsToast';
import { EventsBar } from '@gem/call/CallView/Shared/EventsBar/EventsBar';
import { AddKeyPressHandler } from '@gem/keyboard-handler';

import { ConnectionWarning } from '../Shared/ConnectionWarning/ConnectionWarning';
import styles from './FullScreenCallView.styles.m.css';
import { GroupCall } from './GroupCall/GroupCall';
import { CallLimitsParticipantsToast } from './Shared/CallLimitsParticipantsToast/CallLimitsParticipantsToast';
import { WaitingRoomToast } from './Shared/WaitingRoomToast/WaitingRoomToast';

export const FullScreenCallView = observer(() => {
  const { call } = useCallContext();

  useEffect(() => {
    call.viewState.hideMembers();
  }, []);

  return (
    <div className={classNames(styles.container)}>
      <GroupCall />
      <AddKeyPressHandler onEsc={call.viewState.collapse} />
      <EventsBar fullScreen />
      <WaitingRoomToast />
      <PermissionsRequestsToast />
      <div className={styles.centralToastsContainer}>
        <ConnectionWarning />
        <CallLimitsParticipantsToast />
      </div>
    </div>
  );
});
